import Vue from 'vue';
import VueRouter from 'vue-router';
import { getURLSearchParams } from '@/utils/utils';

Vue.use(VueRouter);

const routes = [
  {
    path: '/multipleServices/index',
    name: 'multipleServicesIndex',
    component: () => import('@/sub-app/multipleServices/pages/index.vue'),
    meta: {
      title: '',
      keepAlive: true,
    },
  },
  {
    path: '/multipleServices/myApply',
    name: 'multipleServicesMyApply',
    component: () => import('@/sub-app/multipleServices/pages/myApply.vue'),
    meta: {
      title: '我的申请',
      keepAlive: false,
    },
  },
  {
    path: '/multipleServices/detail',
    name: 'multipleServicesMyDetail',
    component: () => import('@/sub-app/multipleServices/pages/detail.vue'),
    meta: {
      title: '详情',
      keepAlive: false,
    },
  },
  {
    path: '/multipleServices/apply',
    name: 'multipleServicesApply',
    component: () => import('@/sub-app/multipleServices/pages/apply.vue'),
    meta: {
      title: '我要申请',
      keepAlive: false,
    },
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  // 设置webview标题
  let title = to.meta?.title || '';
  const urlParams = getURLSearchParams();
  if (urlParams && urlParams.title) {
    title = decodeURIComponent(urlParams.title);
  }
  document.title = title;
  next();
});

export default router;
